<button
  [id]="'checkoutButton' + record.id"
  *ngIf="!isMoreOption"
  class="accent"
  mat-flat-button
  [class.waiting]="waiting"
  appStopPropagation
  (click)="doCheckout()">
  <ng-container *ngIf="!waiting">
    {{ 'button.checkout' | translateByCustomerType: customerType.dbValue }}
  </ng-container>
  <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
</button>
<button mat-menu-item *ngIf="isMoreOption" appStopPropagation (click)="doCheckout()">
  <span class="odilo-icon" aria-hidden="true">{{ recordIcon }}</span>
  {{ 'button.checkout' | translateByCustomerType: customerType.dbValue }}
</button>

<opac-recaptcha-dialog (resolved)="resolvedCaptcha($event)"></opac-recaptcha-dialog>
